<template>
  <loading :active="this.allPageLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="true"
          :color="'#fff'"
          :background-color="'#000'"
          :opacity="'0.8'"
          :loader=" dots">
  </loading>
  <Dialog v-model:visible="showModal" class="w-2/3 bg-white shadow rounded-xl" :modal="true" style="position:relative">
    <loading :active="this.showConnectLinkAccount"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <template #header>
      <div class="text-left text-gray-900 font-semibold">{{lang['components']['Dialog']['ConnectAccountDialog']['connect_account_dialog_title']}}</div>
    </template>
    <div class="flex flex-col space-y-12 my-2 text-sm">
      <div>
        <span v-if="adaccounts != '' && pages != ''" class="text-gray-900 ml-6">
          {{lang['components']['Dialog']['ConnectAccountDialog']['connect_account_dialog_info']}}
        </span>
        （
        <span class="text-gray-500 text-sm break-words">
          {{lang['components']['Dialog']['ConnectFanPageDialog']['connect_fan_page_to_fb_client']}}
        </span>
        ）
      </div>
      <div class="mx-6 space-y-2">
        <label class="block text-gray-900 font-semibold">
          {{lang['components']['Dialog']['ConnectAccountDialog']['connect_account_dialog_adaccount_select_label']}}
        </label>
        <span v-if="adaccounts == ''">{{lang['components']['Dialog']['ConnectAccountDialog']['connect_account_dialog_not_adaccount_select_label']}}</span>
        <Dropdown
          v-if="adaccounts != ''"
          v-model="account"
          :options="adaccounts"
          :filter="true"
          :showClear="true"
          optionLabel="name"
          :placeholder="lang['components']['Dialog']['ConnectAccountDialog']['connect_account_dialog_select_adaccount']"
          class="lg:w-1/3 md:w-2/3 sm:w-2/3 rounded-xl"
          :class="{ 'ring-4 border-blue-400': guideStep === 4 }"
          @change="getIdentity()"
        />
      </div>
      <div v-if="adaccounts != ''" class="mx-6 space-y-2">
        <label class="block text-gray-900 font-semibold">
          {{lang['components']['Dialog']['ConnectAccountDialog']['connect_account_dialog_fan_page_label']}}
        </label>
        <span v-if="pages == ''">{{lang['components']['Dialog']['ConnectAccountDialog']['connect_account_dialog_not_fan_page_label']}}</span>
        <div v-if="pages != ''" class="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-4" :class="{ 'ring-4 border-blue-400': guideStep === 4 }">
          <Card
            v-for="item in pages"
            :key="item.id"
            v-model:id="item.id"
            v-model:title="item.title"
            v-model:imgSrc="item.imgSrc"
            v-model:checked="item.checked"
            v-bind:deleteStatus="false"
            @click="item.checked=!item.checked"
          />
        </div>
      </div>
    </div>
    <template #footer>
      <div class="w-full text-right py-4 border-t border-gray-400">
        <button
          v-if="guideStep == -1"
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-gray-400 transition duration-500 ease-in-out mt-32 border-2"
          @click="cancelFanAdacount()">{{lang['components']['Dialog']['ConnectAccountDialog']['connect_account_dialog_cancel_button_text']}}</button>
        <button
          v-if="adaccounts != '' && pages != ''"
          class="bg-yellow-400 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out mt-32 border-2 border-yellow-400"
          :class="{ 'ring-4 border-blue-400': guideStep === 4 }"
          @click="addFanAdacount()">{{lang['components']['Dialog']['ConnectAccountDialog']['connect_account_dialog_check_text']}}</button>
      </div>
    </template>
  </Dialog>
  <OrderDetailDialog :list="details" v-model:show="showDetail" />
</template>

<script>
  import Dialog from 'primevue/dialog';
  import Dropdown from 'primevue/dropdown';
  import Card from '@/components/LinkAccount/Card.vue'
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'ConnectAccountDialog',
    components: {
      Dialog,
      Dropdown,
      Card,
      Swal,
      Loading
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      lang: {
        type: Object
      },
      guideStep: {
        type: Number,
        default: -1
      },
      topOpen: {
        type: String
      },
    },
    data() {
      return {
        allPageLoading: false,
        showConnectLinkAccount: false,
        showDetail: false,
        account: null,
        adaccounts: null,
        pages: null
        // adaccounts: [
        //   { name: 'op1', code: 'op1' },
        //   { name: 'op2', code: 'op2' },
        //   { name: 'op3', code: 'op3' },
        // ],
        // pages: [
        //   { id: '43789578971', title: 'Future Lab1', checked: true},
        //   { id: '43789578972', title: 'Future Lab2', checked: false},
        //   { id: '43789578973', title: 'Future Lab3', checked: false},
        //   { id: '43789578974', title: 'Future Lab4', checked: false},
        // ]
      }
    },
    created() {
      //console.log('add account');
      axios
        .post('https://www.autoturn.net/api/tiktok/campaign/advertiser.php', Qs.stringify({
          s_code: this.$route.params.id
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            // console.log('response:'+response.data);
            // self.first_name = response.data.firstName;
            // this.first_name = response.data.firstName
            this.adaccounts = response.data.return_adaccounts_data;
          }
        });
    },
    watch:{
      'show':function(v){
        //console.log('connectaccountdialog show:'+v);

        if(v == true){
          //console.log('reset');
          axios
            .post('https://www.autoturn.net/api/tiktok/campaign/advertiser.php', Qs.stringify({
              s_code: this.$route.params.id
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                // console.log('response:'+response.data);
                // self.first_name = response.data.firstName;
                // this.first_name = response.data.firstName
                this.adaccounts = response.data.return_adaccounts_data;
              }

              this.showConnectLinkAccount = false;
            });
        }
      },
      'topOpen':function(v){
        let status = v.split('_');

        //console.log(status);

        if(status[0] == 'true'){
          this.tosWindows(status[1]);
        }
      },
      'guideStep':function(v){
        //console.log('accound dialog guideStep');
        //console.log(v);
      }
    },
    methods: {
      addFanAdacount(){
        //console.log('account');
        //console.log(this.account);
        //console.log('pages');
        //console.log(this.pages);

        let adaccountId = this.account
        let list = this.pages

        if(adaccountId != null && adaccountId != '' && typeof adaccountId != 'undefined' && list[0].id != null && list[0].id != '' && list[0].id != 0 && typeof list[0].id != 'undefined'){
          let tos_accepted = this.account.tos_accepted
          let code = this.account.code
          let name = this.account.name

          // console.log('code');
          // console.log(code);
          // console.log('tos_accepted');
          // console.log(tos_accepted);

          let isPage = false
          for (let i = 0; i < list.length; i++){
            if(list[i].checked == true){
              isPage = true;
              break;
            }
          }

          if(isPage == true){
            let member_hash = this.$route.params.id

            axios
              .post('https://www.autoturn.net/api/campaign_member_status.php', Qs.stringify({
                s_code: member_hash,
                route_type: this.$route.params.type,
                active: 'member',
              }))
              .then((caResponse) => {

                if(caResponse.data.status == 'error'){
                  if(caResponse.data.type == 2){
                    Swal.fire({
                      icon: caResponse.data.status,
                      title: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['error']['swal_title'],
                      text: caResponse.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['error']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        // this.allPageLoading = true
                        // window.location.href = "https://private.autoturn.net/"+member_hash;

                        this.account = null;

                        var todayForm = new Date();
                        var yearForm = todayForm.getFullYear();
                        var dateForm = String(todayForm.getDate()).padStart(2, '0');
                        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                        todayForm = yearForm + monthForm + dateForm + timeForm;

                        this.$emit('childTiktokConnectAccount', 'true_'+todayForm);
                        this.showModal=false;

                        if(this.guideStep != 1){
                          this.$emit('nextStep', 5);
                        } 
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        // this.allPageLoading = true
                        // window.location.href = "https://private.autoturn.net/"+member_hash;

                        this.account = null;

                        var todayForm = new Date();
                        var yearForm = todayForm.getFullYear();
                        var dateForm = String(todayForm.getDate()).padStart(2, '0');
                        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                        todayForm = yearForm + monthForm + dateForm + timeForm;

                        this.$emit('childTiktokConnectAccount', 'true_'+todayForm);
                        this.showModal=false;

                        if(this.guideStep != 1){
                          this.$emit('nextStep', 5);
                        } 
                      }

                      // if (result.dismiss === Swal.DismissReason.timer) {
                      //   this.allPageLoading = true
                      //   window.location.href = "http://localhost:8080/events-list/"+member_hash+"/"+adaccount_id;
                      // }
                    })
                  } else if(caResponse.data.type == 3){
                    Swal.fire({
                      icon: caResponse.data.status,
                      title: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['error']['swal_title'],
                      text: caResponse.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['error']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      // if (result.isConfirmed) {
                      //   // Swal.fire('Saved!', '', 'success')
                      //   this.allPageLoading = true
                      //   window.location.href = "http://localhost:8080/"+member_hash;
                      // } else if (result.isDenied) {
                      //   // Swal.fire('Changes are not saved', '', 'info')
                      //   this.allPageLoading = true
                      //   window.location.href = "http://localhost:8080/"+member_hash;
                      // }

                      // if (result.dismiss === Swal.DismissReason.timer) {
                      //   this.allPageLoading = true
                      //   window.location.href = "http://localhost:8080/"+member_hash;
                      // }
                    })
                  } else {
                    Swal.fire(
                              this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['error']['swal_title'],
                              caResponse.data.info,
                              caResponse.data.status
                            )
                  }
                }

                if(caResponse.data.status == 'warning'){
                  Swal.fire({
                    icon: 'warning',
                    title: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['warning']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['warning']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.showConnectLinkAccount = true;

                      // var iHeight = 600;
                      // var iWidth = 1000;
                      // //获得窗口的垂直位置
                      // var iTop = (window.screen.availHeight - 30 - iHeight) / 2;
                      // //获得窗口的水平位置
                      // var iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
                      // var windowStyle = 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,titlebar=no';

                      // if(tos_accepted == false){
                      //   Swal.fire({
                      //     icon: 'warning',
                      //     title: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['warning']['tos_accepted']['if_swal_title'],
                      //     html: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['warning']['tos_accepted']['if_html_a']+name+this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['warning']['tos_accepted']['if_html_b'],
                      //     showDenyButton: false,
                      //     showCancelButton: false,
                      //     confirmButtonText: '確定',
                      //     // denyButtonText: `Don't save`,
                      //   }).then((result) => {
                      //     if(this.guideStep != 1){
                      //       this.$emit('nextStep');
                      //     }

                      //     if (result.isConfirmed) {
                      //       var ch_window = window.open('https://www.facebook.com/customaudiences/app/tos/?'+code, '', windowStyle);

                      //       var timer = setInterval(function() {
                      //         console.log('warning ch_window:', ch_window);
                      //         if(ch_window.closed) {
                      //           clearInterval(timer);
                      //           // window.location.reload();
                      //         }
                      //       }, 1000);

                      //       // setInterval(function () {
                      //       //     try {
                      //       //         if(ch_window.closed) ch_window = null;
                      //       //     } catch (e) {
                      //       //         if (page_reload != 1){
                      //       //             window.location.reload();
                      //       //             page_reload = 1;
                      //       //         }
                      //       //     }
                      //       // }, 1000);
                      //     } else if (result.isDenied) {
                      //       var ch_window = window.open('https://www.facebook.com/customaudiences/app/tos/?'+code, '', windowStyle);
                      //       // var page_reload = 0;

                      //       var timer = setInterval(function() {
                      //         console.log('warning ch_window:', ch_window);
                      //         if(ch_window.closed) {
                      //           console.log('已關閉');
                      //           clearInterval(timer);
                      //           // window.location.reload();
                      //         }
                      //       }, 1000);


                      //       // setInterval(function () {
                      //       //     try {
                      //       //         if(ch_window.closed) ch_window = null;
                      //       //     } catch (e) {
                      //       //         if (page_reload != 1){
                      //       //             window.location.reload();
                      //       //             page_reload = 1;
                      //       //         }
                      //       //     }
                      //       // }, 1000);
                      //     }
                      //   })
                      // } else {
                      //   Swal.fire({
                      //     title: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['warning']['tos_accepted']['else_swal_title'],
                      //     html: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['warning']['tos_accepted']['else_html'],
                      //     icon: 'warning',
                      //     showCancelButton: true,
                      //     confirmButtonColor: '#3085d6',
                      //     cancelButtonColor: '#d33',
                      //     confirmButtonText: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['warning']['tos_accepted']['yes_button'],
                      //     cancelButtonText: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['warning']['tos_accepted']['no_button'],
                      //   }).then((result) => {
                      //     if (result.isConfirmed) {
                      //       axios
                      //         .post('https://www.autoturn.net/api/tiktok/data/tiktok_advertiser_identity_add.php', Qs.stringify({
                      //           s_code: this.$route.params.id,
                      //           adaccount_id: adaccountId,
                      //           form_data: list
                      //         }))
                      //         .then((response) => {
                      //           // console.log(response.data);
                      //           // if(response.data.status == 'success'){
                      //             // this.$swal(response.data.info);
                      //             Swal.fire({
                      //               icon: response.data.status,
                      //               title: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['warning']['tos_accepted']['fan_adaccount_add']['swal_title'],
                      //               text: response.data.info,
                      //               showDenyButton: false,
                      //               showCancelButton: false,
                      //               confirmButtonText: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['warning']['tos_accepted']['fan_adaccount_add']['confirm_button'],
                      //               // denyButtonText: `Don't save`,
                      //             }).then((result) => {
                      //               if (result.isConfirmed) {
                      //                 // Swal.fire('Saved!', '', 'success')
                      //                 // this.allPageLoading = true;
                      //                 // window.location.reload();
                      //                 this.account = null;

                      //                 var todayForm = new Date();
                      //                 var yearForm = todayForm.getFullYear();
                      //                 var dateForm = String(todayForm.getDate()).padStart(2, '0');
                      //                 var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                      //                 var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                      //                 todayForm = yearForm + monthForm + dateForm + timeForm;

                      //                 this.$emit('childTiktokConnectAccount', 'true_'+todayForm);
                      //                 this.showModal=false;
                      //                 if(this.guideStep != 1){
                      //                   this.$emit('nextStep', 6);
                      //                 }
                      //               } else if (result.isDenied) {
                      //                 // Swal.fire('Changes are not saved', '', 'info')
                      //                 // this.allPageLoading = true;
                      //                 // window.location.reload();
                      //                 this.account = null;

                      //                 var todayForm = new Date();
                      //                 var yearForm = todayForm.getFullYear();
                      //                 var dateForm = String(todayForm.getDate()).padStart(2, '0');
                      //                 var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                      //                 var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                      //                 todayForm = yearForm + monthForm + dateForm + timeForm;

                      //                 this.$emit('childTiktokConnectAccount', 'true_'+todayForm);
                      //                 this.showModal=false;
                      //                 if(this.guideStep != 1){
                      //                   this.$emit('nextStep', 6);
                      //                 }
                      //               }
                      //             })
                      //             // this.showModal=false;
                      //           // }
                      //         });
                      //     } else {
                      //       this.showConnectLinkAccount = false;
                      //     }
                      //   })
                      // }
                    }
                  });
                }

                if(caResponse.data.status == 'success'){
                  this.showConnectLinkAccount = true;

                  // tos_accepted = false;

                  // var iHeight = 600;
                  // var iWidth = 1000;
                  // //获得窗口的垂直位置
                  // var iTop = (window.screen.availHeight - 30 - iHeight) / 2;
                  // //获得窗口的水平位置
                  // var iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
                  // var windowStyle = 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,titlebar=no';

                  // if(tos_accepted == false){
                  //   Swal.fire({
                  //     icon: 'warning',
                  //     title: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['success']['tos_accepted']['if_swal_title'],
                  //     html: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['success']['tos_accepted']['if_html_a']+name+this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['success']['tos_accepted']['if_html_b'],
                  //     showDenyButton: false,
                  //     showCancelButton: false,
                  //     confirmButtonText: '確定',
                  //     // denyButtonText: `Don't save`,
                  //   }).then((result) => {
                  //     if(this.guideStep != 1){
                  //       this.$emit('nextStep', code);
                  //     }

                  //     if (result.isConfirmed) {
                  //       var ch_window = window.open('https://www.facebook.com/customaudiences/app/tos/?'+code, '', windowStyle);

                  //       var timer = setInterval(function() {
                  //         console.log('success ch_window:', ch_window);
                  //         if(ch_window.closed) {
                  //           console.log('已關閉');
                  //           clearInterval(timer);
                  //           // window.location.reload();
                  //         }
                  //       }, 1000);

                  //       // setInterval(function () {
                  //       //     try {
                  //       //         if(ch_window.closed) ch_window = null;
                  //       //     } catch (e) {
                  //       //         if (page_reload != 1){
                  //       //             window.location.reload();
                  //       //             page_reload = 1;
                  //       //         }
                  //       //     }
                  //       // }, 1000);
                  //     } else if (result.isDenied) {
                  //       var ch_window = window.open('https://www.facebook.com/customaudiences/app/tos/?'+code, '', windowStyle);
                  //       // var page_reload = 0;

                  //       var timer = setInterval(function() {
                  //         console.log('success ch_window:', ch_window);
                  //         if(ch_window.closed) {
                  //           console.log('已關閉');
                  //           clearInterval(timer);
                  //           // window.location.reload();
                  //         }
                  //       }, 1000);


                  //       // setInterval(function () {
                  //       //     try {
                  //       //         if(ch_window.closed) ch_window = null;
                  //       //     } catch (e) {
                  //       //         if (page_reload != 1){
                  //       //             window.location.reload();
                  //       //             page_reload = 1;
                  //       //         }
                  //       //     }
                  //       // }, 1000);
                  //     }
                  //   })
                  // } else {
                    Swal.fire({
                      title: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['success']['tos_accepted']['else_swal_title'],
                      html: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['success']['tos_accepted']['else_html'],
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#d33',
                      confirmButtonText: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['success']['tos_accepted']['yes_button'],
                      cancelButtonText: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['success']['tos_accepted']['no_button'],
                    }).then((result) => {
                      if (result.isConfirmed) {
                        axios
                          .post('https://www.autoturn.net/api/tiktok/data/tiktok_advertiser_identity_add.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            adaccount_id: adaccountId,
                            form_data: list
                          }))
                          .then((response) => {
                            // console.log(response.data);
                            // if(response.data.status == 'success'){
                              // this.$swal(response.data.info);
                              Swal.fire({
                                icon: response.data.status,
                                title: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['success']['tos_accepted']['fan_adaccount_add']['swal_title'],
                                text: response.data.info,
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonText: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['axios']['success']['tos_accepted']['fan_adaccount_add']['confirm_button'],
                                // denyButtonText: `Don't save`,
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  // Swal.fire('Saved!', '', 'success')
                                  // this.allPageLoading = true;
                                  // window.location.reload();
                                  this.account = null;

                                  var todayForm = new Date();
                                  var yearForm = todayForm.getFullYear();
                                  var dateForm = String(todayForm.getDate()).padStart(2, '0');
                                  var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                                  var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                                  todayForm = yearForm + monthForm + dateForm + timeForm;

                                  this.$emit('childTiktokConnectAccount', 'true_'+todayForm);
                                  this.showModal=false;
                                  if(this.guideStep != 1){
                                    this.$emit('nextStep', 6);
                                  } 
                                } else if (result.isDenied) {
                                  // Swal.fire('Changes are not saved', '', 'info')
                                  // this.allPageLoading = true;
                                  // window.location.reload();
                                  this.account = null;

                                  var todayForm = new Date();
                                  var yearForm = todayForm.getFullYear();
                                  var dateForm = String(todayForm.getDate()).padStart(2, '0');
                                  var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                                  var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                                  todayForm = yearForm + monthForm + dateForm + timeForm;

                                  this.$emit('childTiktokConnectAccount', 'true_'+todayForm);
                                  this.showModal=false;
                                  if(this.guideStep != 1){
                                    this.$emit('nextStep', 6);
                                  } 
                                }
                              })
                              // this.showModal=false;
                            // }
                          });
                      } else {
                        this.showConnectLinkAccount = false;
                      }
                    })
                  // }
                }

                if(caResponse.data.status == 'login'){
                  Swal.fire({
                    icon: 'error',
                    title: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['login']['swal_title'],
                    text: this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['login']['swal_text'],
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: '確定'
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      // this.allPageLoading = true
                      window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      // this.allPageLoading = true
                      window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                    }
                  })
                }
              });
          } else {
            Swal.fire(
                        this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['is_not_page_swal_title'],
                        this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['is_not_page_swal_text'],
                        "warning"
                      )
          }

        } else {
          Swal.fire(
                      this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['else']['swal_title'],
                      this.lang['components']['Dialog']['ConnectAccountDialog']['addFanAdacount']['else']['swal_text'],
                      "error"
                    )
        }
      },
      cancelFanAdacount(){
        this.account = null;

        this.showModal = false;
      },
      getIdentity(){
        //console.log('getIdentity');
        //console.log(this.account);

        if(this.account == null || this.account == '' || typeof this.account == 'undefined'){
          this.pages = [];
        } else {
          axios
            .post('https://www.autoturn.net/api/tiktok/campaign/identity.php', Qs.stringify({
              s_code: this.$route.params.id,
              account: this.account.code
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                // console.log('response:'+response.data);
                // self.first_name = response.data.firstName;
                // this.first_name = response.data.firstName
                this.pages = response.data.return_pages_data;
              }
            });
        }
      }
    },
    computed: {
      showModal: {
        get: function () {
          return this.show
        },
        set: function (value) {
          this.$emit('update:show', value)
        }
      }
    }
  }
</script>

<style lang="scss" scope>
  .record-table {
    button {
      opacity: 0;
    }

    tr {
      &:hover {
        button {
          opacity: 1;
        }
      }
    }
  }
</style>